<div class="cm-skeleton-table">
  <!-- Table header -->
  <div class="cm-skeleton-table-header">
    @for (col of [].constructor(tableColumns()); track $index) {
      <div class="cm-skeleton-table-header-cell">
        <div class="cm-skeleton cm-skeleton--text cm-skeleton--md cm-skeleton--{{ animation() }}"
             [style.width]="$index === 0 ? '60%' : '70%'"></div>
      </div>
    }
  </div>

  <!-- Table rows -->
  @for (row of [].constructor(tableRows()); track $index) {
    <div class="cm-skeleton-table-row">
      @for (col of [].constructor(tableColumns()); track $index) {
        <div class="cm-skeleton-table-cell">
          <div class="cm-skeleton cm-skeleton--text cm-skeleton--md cm-skeleton--{{ animation() }}"
               [style.width]="$index === 0 ? '75%' : '65%'"></div>
        </div>
      }
    </div>
  }
</div>
